import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { initialDocDetailsState } from "./document-details.state";
import { DocDetailsPageDetails } from "../../models/document-details-state.model";

const documentDetailsSlice = createSlice({
  name: "documentDetails",
  initialState: initialDocDetailsState,
  reducers: {
    setPageDetails: (
      state,
      { payload }: PayloadAction<DocDetailsPageDetails>
    ) => {
      state.pageDetails = payload;
    }
  }
});

export default documentDetailsSlice.reducer;
export const documentDetailsActions = documentDetailsSlice.actions;
